<script>
import { required } from 'vuelidate/lib/validators'

import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Service from './service'

import axios from 'axios'

export default {
	page: {
		title: 'Service Alerts',
		meta: [{ name: 'description', content: 'description' }],
	},
	components: { Layout, PageHeader, Service },
	data() {
		return {
			title: 'Service Alerts',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Service Alerts',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Service :url="'/pan/xdr/report/service?include=incident.incident,by360&created_after_minutes=10080&modification_to_now_alarm=120'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
